import axios from "axios"
import { CONST_API_PERSONNEL_DECLARATION_MALADIE_LISTING_ENDPOINT } from "../../../../../../../endpoints"
import { IGetPersonnelMaladieListingRequestModel, IGetPersonnelMaladieResponseModel } from "./_models"

export function getPersonnelMaladiesListingRequest(payload: IGetPersonnelMaladieListingRequestModel) {
     return axios.post<IGetPersonnelMaladieResponseModel>(CONST_API_PERSONNEL_DECLARATION_MALADIE_LISTING_ENDPOINT, payload)
}
